<template>
  <div id="app" :route="$route.name">

    <app-header ></app-header>
    <router-view />
    <banner-newsletter v-if="!hideBannerNewsletter"></banner-newsletter>
    <app-footer ></app-footer>
    <banner-rrss v-if="!hideFooter"></banner-rrss>
    <error></error>
  </div>
</template>

<script>

  require('waypoints/lib/noframework.waypoints.js')

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import bannerNewsletter from '@/components/parts/banner-newsletter';

  import bannerRRSS from '@/components/parts/banner-rrss';

  import error from '@/components/parts/popup-error';



  import { mapActions } from 'vuex';

  export default {
    name: 'App',
    components: {
      'app-header': header,
      'app-footer': footer,
      'banner-newsletter': bannerNewsletter,
      'banner-rrss': bannerRRSS,
      'error': error
    },
    mounted() {
      this.waypoints();

      this.initApp();

      this.$gtag.pageview({
          page_path: this.$route.fullPath,
        })

    },
    watch: {
      '$route': function () {
        let that = this;
        setTimeout(function () {
          that.waypoints();
        }, 100);
        this.$gtag.pageview({
          page_path: this.$route.fullPath,
        })
      }
    },
    methods: {
      ...mapActions(['initApp']),
      waypoints: function () {

        $(".waypoints-instant").addClass('animated fadeInUp');

        var waypoints = document.getElementsByClassName('waypoints');

        for (var i = 0; i < waypoints.length; i++) {

          new Waypoint({
            element: waypoints[i],
            offset: '85%',
            handler: function () {
              var element = this.key.split('-')[1];
              var effect = this.element.attributes.getNamedItem('effect');
              (effect != undefined) ? effect = effect.value : effect = "animate__fadeIn";
              this.element.classList.add("animate__animated", effect)
            }
          });

        }

        var waypoints = document.getElementsByClassName('animation');

        for (var i = 0; i < waypoints.length; i++) {

          new Waypoint({
            element: waypoints[i],
            offset: '80%',
            handler: function () {
              var element = this.key.split('-')[1];
              this.element.classList.add("animation_on")
            }
          });

        }

      }
    },
    computed: {
      hideBannerNewsletter() {
        let hideIn = ['cod','tortujasNinja', 'overwatch'];
        return hideIn.some(e => e == this.$route.name);
      },
      
      hideFooter() {
        let hideIn = ['tortujasNinja'];
        return hideIn.some(e => e == this.$route.name);
      }
    },
  }
</script>

<style lang="scss">
  @import '@/assets/css/colors.scss';
  @import './assets/css/slick.css';
  @import './assets/css/style.scss';
  @import './assets/css/responsive.scss';
  @import './assets/css/momento-ganador.scss';
  @import './assets/css/animaciones.scss';
  @import url('https://fonts.googleapis.com/css?family=Nunito:300,400,700,900&display=swap');
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
</style>


// WEBPACK FOOTER //
// src/App.vue